import { getMint } from "@solana/spl-token";
import { findMintManagerId } from "./pda";
export const identifyCCSToken = async (connection, mintId) => {
    var _a, _b;
    const mintManagerId = findMintManagerId(mintId);
    const mintData = await getMint(connection, mintId);
    return (((_a = mintData.freezeAuthority) === null || _a === void 0 ? void 0 : _a.toString()) === mintManagerId.toString() &&
        ((_b = mintData.mintAuthority) === null || _b === void 0 ? void 0 : _b.toString()) === mintManagerId.toString());
};
//# sourceMappingURL=constants.js.map